import React from "react";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import moment from "moment";
import { Popconfirm } from "antd";
import exportFromBlob from "helpers/export-from-blob";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
// import transactionTypes from "data/transaction-types";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  getList,
  refund,
  exportTransactions
} from "actions/transaction/actions";
import RefundModal from "views/pages/transaction/refund-modal";
import filterTypes from "../../../data/filter-types";

class UserTransactions extends React.Component {
  constructor(props) {
    super(props);

    this.getColumns = this.getColumns.bind(this);
    this.handleRefundModal = this.handleRefundModal.bind(this);
    this.loadTransactions = this.loadTransactions.bind(this);
  }

  loadTransactions(userId) {
    this.props.getList(0, 100, "endDate,DESC", [{
      fieldName: "walletId",
      fieldValue: userId,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }

  componentDidMount() {
    this.loadTransactions(this.props.userId);
  }

  componentDidUpdate(prevProps) {
    if (this.props.userId !== prevProps.userId) {
      this.loadTransactions(this.props.userId);
    }
  }

  handleRefundModal = (transactionId) => {
    const modalObj = {
      modalSettings: {
        size: "sm"
      },
      header: "Refund",
      children: (
        <RefundModal
          onCancel={() => this.props.closeCustomModal(modalObj)}
          onSubmit={() => {
            this.props.refund(
              transactionId,
              () => this.loadTransactions(this.props.userId)
            );
            this.props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  getColumns = () => [
    {
      id: "amount",
      Header: "Amount",
      accessor: "amount",
      width: 100
    },
    {
      id: "currency",
      Header: "Currency",
      accessor: "currency",
      width: 100
    },
    {
      id: "status",
      Header: "Status",
      accessor: "status",
      width: 90
    },
    {
      id: "orderNumber",
      Header: "Order #",
      accessor: "orderNumber",
      width: 90
    },
    {
      id: "startDate",
      Header: "Date",
      accessor: original => moment(original.startDate)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => moment(original.startDate)
        .format("HH:mm YYYY-MM-DD"),
      width: 130
    },
    {
      id: "type",
      Header: "Type",
      accessor: "type",
      width: 90
    },
    {
      id: "ps-account-id",
      Header: "PS Account ID",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (original.paymentProviderAccountId ? (
        <Link to={`/users/${original.paymentProviderAccountId}`}>
          {original.paymentProviderAccountId}
        </Link>
      ) : ""),
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "ps-transaction-id",
      Header: "PS Transaction ID",
      Cell: ({ original }) => original.paymentProviderTransactionId || "",
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "purchaseItemId",
      Header: "Purchase Item Id",
      accessor: "purchaseItemId",
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "purchaseItemType",
      Header: "Purchase Item Type",
      accessor: "purchaseItemType",
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-warning"
          onClick={() => this.handleRefundModal(original.id)}
        >
          Refund
        </button>
      )
    },
  ];

  handleExport = () => {
    this.props.exportTransactions(this.props.userId, (data) => {
      const fileName = `user-transactions-${moment()
        .format("YYYY-MM-DD")}.xls`;
      exportFromBlob(data, fileName);
    });
  };

  render() {
    const {
      loading,
      transactionList,
    } = this.props;

    return (
      <div>
        <div className="text-right">
          <Popconfirm
            title="Are you sure?"
            onConfirm={this.handleExport}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-warning mb-2">
              Export
            </button>
          </Popconfirm>
        </div>
        <ReactTable
          data={transactionList.content || []}
          headerClassName="table-header"
          columns={this.getColumns()}
          pageSizeOptions={[10, 20, 50, 100]}
          resizable
          className="-striped -highlight table-header-padding"
          loading={loading}
          filterable={false}
          defaultFilterMethod={filterCaseInsensitive}
          style={{
            height: "calc(100vh - 150px)"
          }}
        />
      </div>
    );
  }
}

UserTransactions.propTypes = {
  userId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  loading: state.transaction.loading,
  transactionList: state.transaction.transactionList,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
  refund: bindActionCreators(refund, dispatch),
  exportTransactions: bindActionCreators(exportTransactions, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(UserTransactions);



// WEBPACK FOOTER //
// ./src/views/pages/users/user-transactions.js